// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aW","message":"aX","buttons":"aY","buttonWrapper":"aZ","btn":"a0"};